import { call, takeLatest, put } from "redux-saga/effects";
import * as Sentry from "@sentry/react";
import {
  INITIATE_VIEW_FRIEND_DATA,
  SET_FRIEND_SEARCH_QUERY,
  SET_VIEW_FRIEND_DATA,
  SET_VIEW_FRIEND_DATA_FAIL,
  INITIATE_PENDING_TRANSFER_FRIEND_DATA,
  SET_PENDING_TRANSFER_FRIEND_DATA,
  SET_PENDING_TRANSFER_FRIEND_DATA_FAIL,
} from "../../actionTypes/dashboard";
import Friends from "../../../services/api/friend";

// update search query
const updateSearchQuery = (payload) => ({
  type: SET_FRIEND_SEARCH_QUERY,
  payload,
});

// onSuccess handler for friend data api
const onFriendsDataSuccess = (payload) => ({
  type: SET_VIEW_FRIEND_DATA,
  payload,
});

// onFail handler for friend data api
const onFriendsDataFail = (payload) => ({
  type: SET_VIEW_FRIEND_DATA_FAIL,
  payload,
});

/**
 * This function handles the friends data api and sets the data in reducer accordingly
 *
 * @param {object} action contains the data required for this generator function
 */
function* getFriendsData(action) {
  try {
    console.log("PAYLOAD", action.payload);
    const response = yield call(Friends.searchFriend, action.payload);
    yield put(
      onFriendsDataSuccess({
        data: response.content,
        paginationInfo: {
          currentPage: Number(response.number),
          totalPages: Number(response.totalPages),
          totalElements: Number(response.totalElements),
          pageSize: Number(response.size),
        },
      })
    );
    yield put(updateSearchQuery(action.payload.name));
  } catch (error) {
    yield put(onFriendsDataFail(error));
    Sentry.captureException(error);
  }
}

// onSuccess handler for pending transfer data api
const onPendingTransferDataSuccess = (payload) => ({
  type: SET_PENDING_TRANSFER_FRIEND_DATA,
  payload,
});

// onFail handler for pending transfer data api
const onPendingTransferDataFail = (payload) => ({
  type: SET_PENDING_TRANSFER_FRIEND_DATA_FAIL,
  payload,
});

/**
 * This function handles the pending friends data api and sets the data in reducer accordingly
 *
 * @param {object} action contains the data required for this generator function
 */
function* getPendingTransferData(action) {
  try {
    const response = yield call(Friends.getPendingTransfer, action.payload);
    yield put(
      onPendingTransferDataSuccess({
        data: response.content,
        paginationInfo: {
          currentPage: Number(response.number),
          totalPages: Number(response.totalPages),
          totalElements: Number(response.totalElements),
          pageSize: Number(response.size),
        },
      })
    );
  } catch (error) {
    yield put(onPendingTransferDataFail(error));
    Sentry.captureException(error);
  }
}

/**
 * Watcher saga for friends
 */
function* watchFriendsSaga() {
  yield takeLatest(INITIATE_VIEW_FRIEND_DATA, getFriendsData);
  yield takeLatest(
    INITIATE_PENDING_TRANSFER_FRIEND_DATA,
    getPendingTransferData
  );
}
export default watchFriendsSaga;
